<app-page-layout>
  @if (!authResolved()) {
  <section class="home-page">
    <div
      class="home-shell home-shell-auth observatory-pattern-surface observatory-pattern-subtle"
      [class.observatory-pattern-off]="!usePatternedHero"
    >
      <div class="home-topbar">
        <div class="home-title-row">
          <h1>MPC Advanced Queries Interface</h1>
        </div>
      </div>
      <div class="auth-panel auth-panel-loader">
        <div class="loader-orbit" aria-hidden="true"></div>
        <p class="auth-loading" role="status" aria-live="polite">Restoring your session...</p>
      </div>
    </div>
  </section>
  } @else if (!isAuthenticated()) {
  <section class="home-page">
    <div
      class="home-shell home-shell-auth observatory-pattern-surface observatory-pattern-subtle"
      [class.observatory-pattern-off]="!usePatternedHero"
    >
      <div class="home-topbar">
        <div class="home-title-row">
          <h1>MPC Advanced Queries Interface</h1>
        </div>
      </div>

      <div class="auth-panel">
        <div class="auth-panel-copy">
          <h2>Sign in to launch queries</h2>
        </div>
        <app-login [showTitle]="false" />
      </div>
    </div>
  </section>
  } @else {
  <section class="home-page">
    <div
      class="home-shell observatory-pattern-surface observatory-pattern-subtle"
      [class.observatory-pattern-off]="!usePatternedHero"
    >
      <div class="home-topbar">
        <div class="home-title-row">
          <h1>MPC Advanced Queries Interface</h1>
        </div>

        <div class="home-identity">
          <span class="home-identity-label">Signed in</span>
          <strong>{{ displayName() }}</strong>
        </div>
      </div>

      <div class="home-panel telemetry-panel">
        <app-queue-stats
          [showDetails]="false"
          [compact]="true"
          [visiblePollIntervalMs]="homeQueueStatsPollIntervalMs"
          appearance="observatory"
          title="Live Queue Telemetry"
        />
      </div>

      <div class="home-panel query-panel">
        <app-query-form />
      </div>
    </div>
  </section>
  }
</app-page-layout>
